export const loadRecaptcha = () => {
  if (typeof window !== "undefined" && !window.grecaptcha) {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
};
 